// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__27arv","info":"PatientInfo_info__1MLKT"};